import React from 'react';
import PropTypes from 'prop-types';
import { IcoArrowR } from '../../bz/icons';
import { isGlobalVendor, SECTION_BY_ID } from '../registry';
import { Card, SettingRow } from '../SuperAdminAtoms';

// Dashboard.js StatTile markup.
const StatTile = ({ label, value, sub, accent }) => (
  <div className="bz-stat" style={accent ? { borderTop: `3px solid ${accent}` } : undefined}>
    <div className="bz-stat__label">{label}</div>
    <div className="bz-stat__value">{value}</div>
    {sub && <div className="bz-stat__meta bz-truncate">{sub}</div>}
  </div>
);
StatTile.propTypes = {
  label: PropTypes.string,
  value: PropTypes.node,
  sub: PropTypes.string,
  accent: PropTypes.string
};

const Overview = ({ items, tenant, appVersion, onJump }) => {
  const products = items.filter(i => i.typeLabel === 'Product');
  // Global vendors are not switched on or off here, so they are not enabled or disabled.
  const vendors = items.filter(i => i.source === 'vendor' && i.section === 'vendors' && !isGlobalVendor(i));
  const bypass = items.filter(i => i.source === 'bypass' && i.value);
  const attention = items.filter(i => i.attention || !i.registered);
  return (
    <>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16 }}>
        <StatTile
          label="Products on"
          value={`${products.filter(p => p.value).length} / ${products.length}`}
          sub={
            products
              .filter(p => !p.value)
              .map(p => `${p.label} off`)
              .join(', ') || 'All products on'
          }
        />
        <StatTile
          label="Vendors enabled"
          value={`${vendors.filter(v => v.value).length} / ${vendors.length}`}
          sub={`${vendors.filter(v => !v.value).length} disabled`}
        />
        <StatTile
          label="status.io bypass"
          value={bypass.length}
          accent={bypass.length ? 'var(--warn)' : undefined}
          sub={bypass.map(b => b.vendor.name).join(', ') || 'None active'}
        />
        <StatTile
          label="Needs attention"
          value={attention.length}
          accent={attention.length ? 'var(--warn)' : undefined}
          sub="See the list below"
        />
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1.6fr 1fr', gap: 16, alignItems: 'start' }}>
        <Card
          title="Needs attention"
          aside={attention.length ? <span className="bz-pill bz-pill--warn">{attention.length}</span> : null}
        >
          {attention.length ? (
            attention.map(r => (
              <div
                key={r.uid}
                className="bz-row"
                style={{ padding: '12px 0', borderBottom: '1px solid var(--line-soft)', gap: 12 }}
              >
                <div className="bz-grow" style={{ minWidth: 0 }}>
                  <div style={{ fontWeight: 500 }}>{r.logLabel || r.label}</div>
                  <div className="bz-muted" style={{ fontSize: 'var(--fs-sm)' }}>
                    {r.registered ? r.attention : 'No section claims this tenantSettings row yet'} ·{' '}
                    {SECTION_BY_ID[r.section]?.label}
                  </div>
                </div>
                <button type="button" className="bz-btn bz-btn--sm bz-btn--ghost" onClick={() => onJump(r)}>
                  Open <IcoArrowR size={12} />
                </button>
              </div>
            ))
          ) : (
            <div className="bz-muted" style={{ padding: '16px 0' }}>
              Nothing needs attention.
            </div>
          )}
        </Card>
        <Card title="Tenant">
          <SettingRow label="Tenant">
            <span className="bz-mono">{tenant || '—'}</span>
          </SettingRow>
          <SettingRow label="Deployed version">
            <span className="bz-mono">{appVersion || '—'}</span>
          </SettingRow>
        </Card>
      </div>
    </>
  );
};
Overview.propTypes = {
  items: PropTypes.array.isRequired,
  tenant: PropTypes.string,
  appVersion: PropTypes.string,
  onJump: PropTypes.func.isRequired
};

export default Overview;
